var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBowler = function SvgBowler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#625BF6",
    d: "M1.91 9.967c1.966-.254 8.662-1.494 10.427-6.67a6.33 6.33 0 0 0-3.01-1.554 6.35 6.35 0 0 0-4.817.898 6.4 6.4 0 0 0-2.906 5.37c0 .657.1 1.318.306 1.956M13.741 5.18c-1.994 5.282-8.626 6.522-10.77 6.776a6.4 6.4 0 0 0 5.04 2.442 6.35 6.35 0 0 0 3.48-1.034c2.738-1.782 3.661-5.323 2.25-8.184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#625BF6",
    d: "m13.413 4.58-.032-.051a6.4 6.4 0 0 0-.61-.795c-1.953 5.155-8.504 6.467-10.654 6.763.142.339.318.67.52.987 1.56-.152 8.979-1.176 10.776-6.904"
  })));
};
export default SvgBowler;